import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from 'src/store/useAuthStore';

interface GuestGuardProps {
  children: ReactNode;
}

const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuthStore();

  if (isAuthenticated) {
    // Redirect based on role if already authenticated
    if (user?.role === 'super_admin') {
      return <Navigate to="/dashboards/super-admin" replace />;
    }
    return <Navigate to="/dashboards/home" replace />;
  }

  return <>{children}</>;
};

export default GuestGuard;
